import React from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { XIcon, SearchIcon } from "./iconography";

const useStyles = makeStyles((theme) => ({
  searchField: {
    minWidth: "16rem",
  },
  searchFieldMobile: {
    minWidth: "8rem",
  },
  clearButton: {
    marginRight: theme.spacing(-2),
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 250,
  },
  inputContainer: {
    display: "flex",
  },
  searchButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    height: "2.5rem",
  },
}));

const SearchInput = ({
  term,
  setTerm,
  handleSearch,
  termLength = 0,
  clear,
}) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const classes = useStyles();

  const handleSubmit = (evt) => {
    if (evt.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className={classes.inputContainer}>
      <TextField
        id="search"
        name="search"
        size="small"
        variant="outlined"
        margin="dense"
        onChange={(evt) => setTerm(evt.target.value)}
        value={term}
        placeholder="Search"
        className={isSmall ? classes.searchFieldMobile : classes.searchField}
        onKeyDown={handleSubmit}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton disableRipple onClick={clear}>
                <XIcon className={classes.clearButton} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {isSmall ? (
        <IconButton
          variant="outlined"
          className={classes.searchButton}
          size="large"
          onClick={handleSearch}
        >
          <SearchIcon fontSize="large" />
        </IconButton>
      ) : (
        <Button
          className={classes.searchButton}
          size="large"
          disableFocusRipple
          onClick={handleSearch}
          startIcon={<SearchIcon />}
          disabled={!term || term.length < termLength}
        >
          Search
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
